/**
 * Syncs a base field value into all locale-suffixed translation fields
 * while auto-sync is still enabled (user has not manually edited a locale).
 */
export const LOCALIZATION_SUFFIXES = ['_en_us', '_nl_be', '_fr_fr', '_de_de'] as const;

export function hasMissingTranslation(value: string | null | undefined, translations: (string | null | undefined)[]): boolean {
    return value !== '' && value !== null && value !== undefined && translations.some((translation) => translation === '' || translation === null);
}

export function syncLocalizedField<T extends Record<string, unknown>>(
    prev: T,
    field: string,
    value: string,
    options: { syncEnabled: boolean; showTranslations: boolean }
): T {
    if (!options.syncEnabled || !options.showTranslations) {
        return { ...prev, [field]: value };
    }

    const next: Record<string, unknown> = { ...prev, [field]: value };
    for (const suffix of LOCALIZATION_SUFFIXES) {
        next[`${field}${suffix}`] = value;
    }
    return next as T;
}
